import React, { useMemo, useState } from 'react';
import { Box, Button, Container, Typography, Card, CardContent } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { DEFAULT_USERS_TABLE_COLUMNS } from '../constants';
import Table from '../components/Table';
import ConfirmDialog from '../components/ConfirmDialog';
import { getAllLeadAgents, useApproveLeadAgent } from '../queries/users';
import { formatDateWithTimezone } from '../utils/helper';
import { toast } from 'react-toastify';

const LeadAgentsPage = () => {
  const { data: users, isRefetching, refetch } = useQuery(getAllLeadAgents({}));

  const { mutate: approveUser, isPending: isApprovingUser } = useApproveLeadAgent();

  const [selectedUserId, setSelectedUserId] = useState();

  const columns = useMemo(() => DEFAULT_USERS_TABLE_COLUMNS, []);

  const tableData = useMemo(
    () =>
      users?.map((user) => ({
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
        isApproved: user.isApproved ? (
          'Approved'
        ) : (
          <Button onClick={() => setSelectedUserId(user._id)} color='primary' variant='contained'>
            Approve
          </Button>
        ),
        approvedAt: formatDateWithTimezone(user.approvedAt),
      })) || [],
    [users],
  );

  const handleApproveUser = () => {
    approveUser(
      { id: selectedUserId },
      {
        onSuccess: () => {
          refetch();
          setSelectedUserId(undefined);
          toast('Lead Agent was approved successfully!', { type: 'success' });
        },
        onError: (error) => {
          toast(error?.response?.data?.message || error.message, { type: 'error' });
        },
      },
    );
  };

  return (
    <Container maxWidth={false} sx={{ my: 4, px: { xs: 2, md: 3 }, width: '100%', maxWidth: '100%' }}>
      <Card variant='outlined' sx={{ borderRadius: 3, boxShadow: '0 4px 12px rgba(0,0,0,0.06)', p: 2 }}>
        <CardContent>
          <Box display='flex' justifyContent='space-between' alignItems='center' mb={3}>
            <Typography variant='h5' fontWeight='bold' textTransform='uppercase'>
              Lead Agents
            </Typography>
          </Box>

          <Table isLoading={isRefetching} columns={columns} data={tableData} />
        </CardContent>
      </Card>

      <ConfirmDialog
        open={!!selectedUserId}
        loading={isApprovingUser}
        onClose={() => setSelectedUserId(undefined)}
        title='Approve Lead Agent'
        content='Are you sure you want to approve this lead agent?'
        confirmButton='Approve'
        confirmButtonProps={{ color: 'primary', variant: 'contained' }}
        onConfirm={handleApproveUser}
      />
    </Container>
  );
};

export default LeadAgentsPage;
